import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Cookie } from "lucide-react";

const KEY = "hp_cookie_consent";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    if (!localStorage.getItem(KEY)) setVisible(true);
  }, []);

  const decide = (choice) => {
    localStorage.setItem(KEY, JSON.stringify({ choice, at: new Date().toISOString() }));
    if (typeof window.gtag === "function") {
      window.gtag("consent", "update", { analytics_storage: choice === "all" ? "granted" : "denied" });
    }
    setVisible(false);
  };

  if (!visible || pathname.startsWith("/admin")) return null;
  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:max-w-md z-[60] bg-[#0C2E2B] text-white rounded-lg shadow-2xl border border-[#FFDF00]/40 p-4 animate-in slide-in-from-bottom-4 fade-in duration-300"
    >
      <div className="flex items-start gap-3">
        <div className="w-8 h-8 rounded-md bg-[#FFDF00] grid place-items-center shrink-0">
          <Cookie className="w-4 h-4 text-[#0C2E2B]" strokeWidth={2.5} />
        </div>
        <div className="text-xs leading-relaxed">
          We use essential browser storage for your cart, and — only if you allow it — Google Analytics to see which pages
          people visit. No ads, no selling data. Details in our{" "}
          <Link to="/terms#privacy" className="underline font-bold text-[#FFDF00]">Privacy Policy</Link>.
        </div>
      </div>
      <div className="mt-3 flex gap-2 justify-end">
        <button
          data-testid="cookie-decline-btn"
          onClick={() => decide("essential")}
          className="px-3 py-1.5 rounded-md text-xs font-bold border border-white/30 hover:bg-white/10 transition-colors"
        >
          Essential only
        </button>
        <button
          data-testid="cookie-accept-btn"
          onClick={() => decide("all")}
          className="px-3 py-1.5 rounded-md text-xs font-bold bg-[#FFDF00] text-[#0C2E2B] hover:bg-[#E5C900] transition-colors"
        >
          Allow analytics
        </button>
      </div>
    </div>
  );
}
